import CryptoTaxCalculator from './CryptoTaxCalculator.svelte';
import './index.css';

new CryptoTaxCalculator({
  target: document.getElementsByClassName('svelte-app')[0]
});
